import Cookie from "js-cookie"
export default {
  state: {
    //E5核心门户菜单
    coremenu: [],
    //E5核心应用菜单
    coreformMenu: [],
    //E5应用当前用户操作应用名称，使用统一管理，防止浏览器返回等错误
    coreformname: ''
  },
  mutations: {
    //根据返回数据，写入应用菜单列表
    setCoreFormMenu(state, val) { 
      
      state.coreformMenu = val
    },

    //根据返回数据，写入门户菜单菜单列表
    setCoreMenu(state, val) {
      state.coremenu = val
    },
    //写入用户当前操作的应用名称
    setCoreFormName(state, val) {
      state.coreformname = val
      Cookie.set('coreformname', val)
    },
    //获取到客户端存储的当前操作应用名称
    getCoreFormName(state){
      state.coreformname=state.coreformname||Cookie.get('coreformname')
    }
  }


}
